import { FamilyOtherDetailAnscNotificationsMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsOtherDetailCivilStatusShared from 'shell/components/shared/ansc-notifications/research-family/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsOtherDetailCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsOtherDetailCivilStatusShared
        items={FamilyOtherDetailAnscNotificationsMutationCrumbs()}
        scope={IdAmbito.Mutazioni}
      />
    </Fragment>
  );
};

ResearchFamilyNotificationsOtherDetailCivilStatusPage.displayName =
  'Research Family Notifications CivilStatusPage component';

export default ResearchFamilyNotificationsOtherDetailCivilStatusPage;
